import {
  carto,
  esri,
  google,
  jawg,
  kartogiraffe,
  locationiq,
  mapbox,
  mapboxStyle,
  mapboxTwoX,
  mapy,
  thunderforest,
  tomtom,
} from '../../config/urls'
import { createLayer } from '../../layers/factory'

export const baseMaps = createLayer({
  title: 'Base maps',
  type: 'group',
  layers: [
    {
      title: 'OpenStreetMap',
      type: 'group',
      layers: [
        {
          title: 'Standaard',
          type: 'osm',
          base: true,
        },
        {
          title: 'Humanitarian',
          type: 'osm',
          url: 'https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Duitsland',
          type: 'osm',
          url: 'https://{a-c}.tile.openstreetmap.de/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Frankrijk',
          type: 'osm',
          url: 'https://{a-c}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Piano',
          type: 'xyz',
          url: 'https://{a-c}.piano.tiles.quaidorsay.fr/en/{z}/{x}/{y}.png',
          base: true,
          source: {
            maxZoom: 16,
            attributions: 'map data \u00a9 <a href=\'https://osm.org/copyright\' target=\'_blank\'>OpenStreetMap contributors</a> under ODbL - tiles \u00a9 <a href=\'https://github.com/tilery/pianoforte\' target=\'_blank\'>Min. Aff. \u00c9trang\u00e8res</a>',
          },
        },
        {
          title: 'Forte',
          type: 'xyz',
          url: 'https://{a-c}.forte.tiles.quaidorsay.fr/en/{z}/{x}/{y}.png',
          base: true,
          source: {
            maxZoom: 16,
            attributions: 'map data \u00a9 <a href=\'https://osm.org/copyright\' target=\'_blank\'>OpenStreetMap contributors</a> under ODbL - tiles \u00a9 <a href=\'https://github.com/tilery/pianoforte\' target=\'_blank\'>Min. Aff. \u00c9trang\u00e8res</a>',
          },
        },
      ],
    },
    {
      title: 'Google',
      type: 'group',
      layers: [
        {
          title: 'Road',
          type: 'xyz',
          url: google('m'),
          base: true,
          source: {
            maxZoom: 22,
          },
        },
        {
          title: 'Road Altered',
          type: 'xyz',
          url: google('r'),
          base: true,
          source: {
            maxZoom: 22,
          },
        },
        {
          title: 'Terrain',
          type: 'xyz',
          url: google('p'),
          base: true,
          source: {
            maxZoom: 22,
          },
        },
        {
          title: 'Hybrid',
          type: 'xyz',
          url: google('y'),
          base: true,
          source: {
            maxZoom: 22,
          },
        },
        {
          title: 'Satellite',
          type: 'xyz',
          url: google('s'),
          base: true,
          source: {
            maxZoom: 22,
          },
        },
      ],
    },
    {
      title: 'PDOK',
      type: 'group',
      layers: [
        {
          title: 'BRT-Achtergrondkaart',
          type: 'wmts',
          url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'standaard',
          },
          layer: {
            maxZoom: 19.5,
          },
        },
        {
          title: 'BRT-Achtergrondkaart Pastel',
          type: 'wmts',
          url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'pastel',
          },
          layer: {
            maxZoom: 19.5,
          },
        },

        {
          title: 'BRT-Achtergrondkaart Grijs',
          type: 'wmts',
          url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0?',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'grijs',
          },
          layer: {
            maxZoom: 19.5,
          },
        },
        {
          title: 'BRT-Achtergrondkaart Water',
          type: 'wmts',
          url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0?',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'water',
          },
          layer: {
            maxZoom: 19.5,
          },
        },
        {
          title: 'BGT-Achtergrondkaart (ZOOM IN!)',
          type: 'wmts',
          url: 'https://service.pdok.nl/lv/bgt/wmts/v1_0?service=WMTS&',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'achtergrondvisualisatie',
          },
          layer: {
            minZoom: 16.5,
            maxZoom: 19.5,
          },
        },
        {
          title: 'BGT-Standaard (ZOOM IN!)',
          type: 'wmts',
          url: 'https://service.pdok.nl/lv/bgt/wmts/v1_0?service=WMTS&',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'standaardvisualisatie',
          },
          layer: {
            minZoom: 16.5,
            maxZoom: 19.5,
          },
        },
        {
          title: 'BGT-Pastel (ZOOM IN!)',
          type: 'wmts',
          url: 'https://service.pdok.nl/lv/bgt/wmts/v1_0?service=WMTS&',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'pastelvisualisatie',
          },
          layer: {
            minZoom: 16.5,
            maxZoom: 19.5,
          },
        },
        {
          title: 'Luchtfotos (definitief actueel)',
          type: 'wmts',
          url: 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0?',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'Actueel_ortho25',
          },
          layer: {
            maxZoom: 19.5,
          },
        },
        {
          title: 'Luchtfotos (definitief actueel HR)',
          type: 'wmts',
          url: 'https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0?',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'Actueel_orthoHR',
          },
          layer: {
            maxZoom: 19.5,
          },
        },
      ],
    },
    {
      title: 'TopNL',
      type: 'group',
      layers: [
        {
          title: '10 - Zoom 14-16',
          type: 'wmts',
          url: 'https://service.pdok.nl/brt/top10nl/wmts/v1_0?service=wmts?',
          projection: 'EPSG:28992',
          base: true,
          source: {
            layer: 'top10nl',
          },
          layer: {
            minZoom: 13.5,
            maxZoom: 16.5,
          },
        },
        {
          title: '25 - Zoom 13-16',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top25raster',
          layer: {
            minZoom: 13.5,
            maxZoom: 16.5,
          },
          base: true,
        },
        {
          title: '50 - Zoom 12-15',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top50raster',
          layer: {
            minZoom: 12.5,
            maxZoom: 15.5,
          },
          base: true,
        },
        {
          title: '100 - Zoom 11-14',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top100raster',
          layer: {
            minZoom: 11.5,
            maxZoom: 14.5,
          },
          base: true,
        },
        {
          title: '250 - Zoom 10-13',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top250raster',
          layer: {
            minZoom: 9.5,
            maxZoom: 12.5,
          },
          base: true,
        },
        {
          title: '500 - Zoom 9-12',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top500raster',
          layer: {
            minZoom: 8.5,
            maxZoom: 11.5,
          },
          base: true,
        },
        {
          title: '1000 - Zoom 8-11',
          type: 'wms',
          url: 'https://service.pdok.nl/brt/topraster/wms/v1_0?service=wms',
          layers: 'top1000raster',
          layer: {
            minZoom: 7.5,
            maxZoom: 10.5,
          },
          base: true,
        },
        {
          title: 'BRT Top10nl Vector',
          type: 'mapboxStyle',
          url: 'https://api.pdok.nl/kadaster/brt-top10nl/ogc/v1/styles/brt_top10nl__webmercatorquad?f=mapbox',
          base: true,
        },
      ],
    },
    {
      title: 'ESRI',
      type: 'group',
      layers: [
        {
          title: 'Satellite',
          type: 'xyz',
          url: esri('World_Imagery'),
          base: true,
          source: {
            maxZoom: 21,
          },
        },
        {
          title: 'Oceans',
          type: 'xyz',
          url: esri('Ocean/World_Ocean_Base'),
          base: true,
          source: {
            maxZoom: 16, // 16 in US, 10 outside US
          },
        },
        {
          title: 'National Geographic',
          type: 'xyz',
          url: esri('NatGeo_World_Map'),
          base: true,
          source: {
            maxZoom: 16, // 16 in US, 12 outside US
          },
        },
        {
          title: 'USA Topo',
          type: 'xyz',
          url: esri('USA_Topo_Maps'),
          base: true,
          source: {
            maxZoom: 15, // 15 in US, 8 outside US
          },
        },
        {
          title: 'World Physical Map',
          type: 'xyz',
          url: esri('World_Physical_Map'),
          base: true,
          layer: {
            maxZoom: 8,
          },
        },
        {
          title: 'Standard',
          type: 'xyz',
          url: esri('World_Street_Map'),
          base: true,
        },
        {
          title: 'World Terrain Base',
          type: 'xyz',
          url: esri('World_Terrain_Base'),
          base: true,
          layer: {
            maxZoom: 9,
          },
        },
        {
          title: 'World Topo Map',
          type: 'xyz',
          url: esri('World_Topo_Map'),
          base: true,
        },
        {
          title: 'Canvas Dark Gray Base',
          type: 'xyz',
          url: esri('Canvas/World_Dark_Gray_Base'),
          base: true,
        },
        {
          title: 'Canvas Light Gray Base',
          type: 'xyz',
          url: esri('Canvas/World_Light_Gray_Base'),
          base: true,
        },
        {
          title: 'Navigation Charts',
          type: 'xyz',
          url: esri('Specialty/World_Navigation_Charts'),
          base: true,
          layer: {
            maxZoom: 10,
          },
        },
      ],
    },
    {
      title: 'Stamen/StadiaMaps',
      type: 'group',
      layers: [
        {
          title: 'Stamen Terrain',
          type: 'stadia',
          source: {
            layer: 'stamen_terrain',
          },
          base: true,
        },
        {
          title: 'Stamen Terrain Background',
          type: 'stadia',
          source: {
            layer: 'stamen_terrain_background',
          },
          base: true,
        },
        {
          title: 'Stamen Toner',
          type: 'stadia',
          source: {
            layer: 'stamen_toner',
          },
          base: true,
        },
        {
          title: 'Stamen Toner Background',
          type: 'stadia',
          source: {
            layer: 'stamen_toner_background',
          },
          base: true,
        },
        {
          title: 'Stamen Toner Lite',
          type: 'stadia',
          source: {
            layer: 'stamen_toner_lite',
          },
          base: true,
        },
        {
          title: 'Stamen Watercolor',
          type: 'stadia',
          source: {
            layer: 'stamen_watercolor',
          },
          base: true,
        },
        {
          title: 'Alidade Smooth',
          type: 'stadia',
          source: {
            layer: 'alidade_smooth',
          },
          base: true,
        },
        {
          title: 'Alidade Smooth Dark',
          type: 'stadia',
          source: {
            layer: 'alidade_smooth_dark',
          },
          base: true,
        },
        {
          title: 'OSM Bright',
          type: 'stadia',
          source: {
            layer: 'osm_bright',
          },
          base: true,
        },
        {
          title: 'Stadia Outdoors',
          type: 'xyz',
          url: 'https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}@2x.png',
          base: true,
        },
      ],
    },
    {
      title: 'Thunderforest',
      type: 'group',
      layers: [
        {
          title: 'Open Cycle Map',
          type: 'osm',
          url: thunderforest('cycle'),
          base: true,
        },
        {
          title: 'Transport',
          type: 'osm',
          url: thunderforest('transport'),
          base: true,
        },
        {
          title: 'Transport Dark',
          type: 'osm',
          url: thunderforest('transport-dark'),
          base: true,
        },
        {
          title: 'Landscape',
          type: 'osm',
          url: thunderforest('landscape'),
          base: true,
        },
        {
          title: 'Outdoors',
          type: 'osm',
          url: thunderforest('outdoors'),
          base: true,
        },
        {
          title: 'Spinal Map',
          type: 'osm',
          url: thunderforest('spinal-map'),
          base: true,
        },
        {
          title: 'Pioneer',
          type: 'osm',
          url: thunderforest('pioneer'),
          base: true,
        },
        {
          title: 'Mobile Atlas',
          type: 'osm',
          url: thunderforest('mobile-atlas'),
          base: true,
        },
        {
          title: 'Neighbourhood',
          type: 'osm',
          url: thunderforest('neighbourhood'),
          base: true,
        },
      ],
    },
    {
      title: 'TomTom',
      type: 'group',
      layers: [
        {
          title: 'Basic Main',
          type: 'osm',
          url: tomtom('basic/main'),
          base: true,
        },
        {
          title: 'Basic Night',
          type: 'osm',
          url: tomtom('basic/night'),
          base: true,
        },
      ],
    },
    {
      title: 'Mapbox',
      type: 'group',
      // Todo: implement correct use of 2x HiDPI / Retina sources.
      layers: [
        {
          title: 'Standard Vector',
          type: 'mapboxStyle',
          url: mapboxStyle('standard'),
          base: true,
        },
        {
          title: 'Satellite',
          type: 'osm',
          url: mapbox('satellite-v9'),
          base: true,
        },
        {
          title: 'Satellite 2x',
          type: 'osm',
          url: mapboxTwoX('satellite-v9'),
          base: true,
        },
        {
          title: 'Streets',
          type: 'osm',
          url: mapbox('streets-v11'),
          base: true,
        },
        {
          title: 'Streets 2x',
          type: 'osm',
          url: mapboxTwoX('streets-v11'),
          base: true,
        },
        {
          title: 'Outdoors',
          type: 'osm',
          url: mapbox('outdoors-v11'),
          base: true,
        },
        {
          title: 'Outdoors 2x',
          type: 'osm',
          url: mapboxTwoX('outdoors-v11'),
          base: true,
        },
        {
          title: 'Light',
          type: 'osm',
          url: mapbox('light-v10'),
          base: true,
        },
        {
          title: 'Light 2x',
          type: 'osm',
          url: mapboxTwoX('light-v10'),
          base: true,
        },
        {
          title: 'Dark',
          type: 'osm',
          url: mapbox('dark-v10'),
          base: true,
        },
        {
          title: 'Dark 2x',
          type: 'osm',
          url: mapboxTwoX('dark-v10'),
          base: true,
        },
        {
          title: 'Satellite and Streets',
          type: 'osm',
          url: mapbox('satellite-streets-v11'),
          base: true,
        },
        {
          title: 'Satellite and Streets 2x',
          type: 'osm',
          url: mapboxTwoX('satellite-streets-v11'),
          base: true,
        },
      ],
    },
    {
      title: 'Carto',
      type: 'group',
      layers: [
        {
          title: 'Dark',
          type: 'osm',
          url: carto('dark_all'),
          base: true,
        },
        {
          title: 'Dark - No labels',
          type: 'osm',
          url: carto('dark_nolabels'),
          base: true,
        },
        {
          title: 'Spotify Dark',
          type: 'osm',
          url: carto('spotify_dark'),
          base: true,
        },
        {
          title: 'Light',
          type: 'osm',
          url: carto('light_all'),
          base: true,
        },
        {
          title: 'Light - No labels',
          type: 'osm',
          url: carto('light_nolabels'),
          base: true,
        },
        {
          title: 'Voyager',
          type: 'osm',
          url: carto('rastertiles/voyager'),
          base: true,
        },
        {
          title: 'Voyager - No labels',
          type: 'osm',
          url: carto('rastertiles/voyager_nolabels'),
          base: true,
        },
      ],
    },
    {
      title: 'LocationIQ',
      type: 'group',
      layers: [
        {
          title: 'LocationIQ Streets',
          type: 'osm',
          url: locationiq('streets'),
          source: {
            attributions: '<a href="https://locationiq.com/?ref=maps" target="_blank">© LocationIQ</a>',
          },
          base: true,
        },
        {
          title: 'LocationIQ Dark',
          type: 'osm',
          url: locationiq('dark'),
          source: {
            attributions: '<a href="https://locationiq.com/?ref=maps" target="_blank">© LocationIQ</a>',
          },
          base: true,
        },
        {
          title: 'LocationIQ Light',
          type: 'osm',
          url: locationiq('light'),
          source: {
            attributions: '<a href="https://locationiq.com/?ref=maps" target="_blank">© LocationIQ</a>',
          },
          base: true,
        },
      ],
    },
    {
      title: 'Mapy',
      type: 'group',
      layers: [
        {
          title: 'Basic map',
          type: 'tilejson',
          url: mapy('basic'),
          source: {
            attributions: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
            maxZoom: 20,
          },
          base: true,
        },
        {
          title: 'Tourist map',
          type: 'tilejson',
          url: mapy('outdoor'),
          source: {
            attributions: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
            maxZoom: 20,
          },
          base: true,
        },
        {
          title: 'Aerial map',
          type: 'tilejson',
          url: mapy('aerial'),
          source: {
            attributions: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
            maxZoom: 20,
          },
          base: true,
        },
        {
          title: 'Winter map',
          type: 'tilejson',
          url: mapy('winter'),
          source: {
            attributions: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
            maxZoom: 20,
          },
          base: true,
        },
      ],
    },
    {
      title: 'Karto Giraffe',
      type: 'group',
      layers: [
        {
          title: 'Base',
          type: 'xyz',
          url: kartogiraffe(),
          base: true,
        },
        {
          title: 'Bicycle',
          type: 'xyz',
          url: kartogiraffe('&type=bicycle'),
          base: true,
        },
        {
          title: 'Hiking',
          type: 'xyz',
          url: kartogiraffe('&type=hiking'),
          base: true,
        },
        {
          title: 'Transport',
          type: 'xyz',
          url: kartogiraffe('&type=transport'),
          base: true,
        },
      ],
    },
    {
      title: 'Waze',
      type: 'group',
      layers: [
        {
          title: 'US',
          type: 'osm',
          url: 'https://livemap-tiles{1-4}.waze.com/tiles/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'World',
          type: 'osm',
          url: 'https://worldtiles{1-4}.waze.com/tiles/{z}/{x}/{y}.png',
          base: true,
        },
      ],
    },
    {
      title: 'JAWG',
      type: 'group',
      layers: [
        {
          title: 'Base',
          type: 'xyz',
          url: jawg(),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
        {
          title: 'Sunny',
          type: 'xyz',
          url: jawg('sunny'),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
        {
          title: 'Light',
          type: 'xyz',
          url: jawg('light'),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
        {
          title: 'Dark',
          type: 'xyz',
          url: jawg('dark'),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
        {
          title: 'Lagoon',
          type: 'xyz',
          url: jawg('jawg-lagoon'),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
        {
          title: 'Terrain',
          type: 'xyz',
          url: jawg('jawg-terrain'),
          base: true,
          source: {
            attributions: 'Tiles courtesy of <a href="https://www.jawg.io/en/" target="_blank">jawgmaps</a>',
          },
        },
      ],
    },
    {
      title: 'FlyToMap',
      type: 'group',
      layers: [
        {
          title: 'Fly To Map',
          type: 'xyz',
          url: 'https://viewer.flytomap.com/ftm_tiles/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Fly To Map No AA',
          type: 'xyz',
          url: 'https://viewer.flytomap.com/noaatiles/{z}/{x}/{y}.png',
          base: true,
        },
      ],
    },
    {
      title: 'Individuals',
      type: 'group',
      layers: [
        {
          title: 'Freie Tonne Seekarte',
          type: 'xyz',
          url: 'https://www.freietonne.de/osm/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Waterkaart Dieptekaart',
          type: 'xyz',
          url: 'https://waterkaart.live/tiles/tileserver_eu.php?xy={z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'Buienradar',
          type: 'xyz',
          url: 'https://tiles.buienradar.nl/tiles-eu-v2/{z}/{x}/{y}.png',
          source: {
            maxZoom: 11,
          },
          base: true,
        },
        {
          title: 'CyclOSM',
          type: 'xyz',
          url: 'https://{a-c}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
          source: {
            maxZoom: 20,
          },
          base: true,
        },
        {
          title: 'WhereGroup',
          type: 'xyz',
          url: 'https://osm-demo-{a-c}.wheregroup.com/tiles/1.0.0/osm/webmercator/{z}/{x}/{y}.png',
          source: {
            maxZoom: 19,
          },
          base: true,
        },
        {
          title: 'AllRailMap',
          type: 'xyz',
          url: 'https://map.allrailmap.com/rail2/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: 'OpenTopoMap',
          type: 'xyz',
          url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
          base: true,
        },
        {
          title: '(noSSL) Apple Maps Classic',
          type: 'xyz',
          url: 'http://gsp2.apple.com/tile?api=1&style=slideshow&layers=default&lang=en_GB&z={z}&x={x}&y={y}&v=9',
          base: true,
        },
        {
          title: 'NASA Blue Marble',
          type: 'xyz',
          url: 'https://wms.openstreetmap.fr/tms/1.0.0/nasa_blue_marble/{z}/{x}/{y}.jpeg',
          source: {
            maxZoom: 9,
            attributions: '<a href="https://earthobservatory.nasa.gov" target="_blank">NASA 2016</a>',
          },
          base: true,
        },
        {
          title: 'NASA Black Marble',
          type: 'xyz',
          url: 'https://wms.openstreetmap.fr/tms/1.0.0/nasa_black_marble/{z}/{x}/{y}.jpeg',
          source: {
            maxZoom: 9,
            attributions: '<a href="https://earthobservatory.nasa.gov/features/NightLights" target="_blank">NASA 2012</a>',
          },
          base: true,
        },
        {
          title: 'Maps For Free',
          type: 'xyz',
          url: 'https://maps-for-free.com/layer/relief/z{z}/row{y}/{z}_{x}-{y}.jpg',
          source: {
            maxZoom: 11,
          },
          base: true,
        },
        {
          title: 'BlueMarble',
          type: 'xyz',
          url: 'https://s3.amazonaws.com/com.modestmaps.bluemarble/{z}-r{y}-c{x}.jpg',
          source: {
            maxZoom: 9,
          },
          base: true,
        },
        {
          title: 'GIBS',
          type: 'xyz',
          url: 'https://gibs-{a-c}.earthdata.nasa.gov/wmts/epsg3857/best/MODIS_Terra_CorrectedReflectance_TrueColor/default/2020-06-15/GoogleMapsCompatible_Level9/{z}/{y}/{x}.jpg',
          source: {
            maxZoom: 9,
          },
          base: true,
        },
        {
          title: 'Transport map',
          type: 'xyz',
          url: 'https://tile.memomaps.de/tilegen/{z}/{x}/{y}.png',
          base: true,
        },
      ],
    },

  ],
})
